module.exports = {
  language       : 'idioma',
  _back          : 'Regresar',
  spanish        : 'Español',
  english        : 'Inglés',
  capture_screen : 'Captura de Pantalla',
  description    : 'Descripción',
  titleApp       : 'Softaculous ( Instalador - Aplicaciones )',
  messageApp     : 'Con nuestros planes podrás acceder al catálogo de 372 aplicaciones listas para instalar con unos pocos clicks.'
}



// WEBPACK FOOTER //
// ./src/translate/es.js